import React from 'react';
import T from 'prop-types';

import FavoriteCompetitors from './FavoriteCompetitors';
import FavoriteComparisons from './FavoriteComparisons';
import Container from '../../../../components/Container';

const CompetitorsComparisonsSection = ({
  competitors,
  comparisons,
  header,
  subheader,
  isMobileView,
}) => (
  <div className="competitors-comparisons-section">
    <Container maxWidth={1248}>
      {header && <h2 className="competitors-comparisons-section__header">{header}</h2>}
      {subheader && (
        <p
          className="competitors-comparisons-section__subheader"
          dangerouslySetInnerHTML={{ __html: subheader }}
        />
      )}
      <div className="competitors-comparisons">
        <FavoriteCompetitors competitors={competitors} isMobileView={isMobileView} />
        <FavoriteComparisons comparisons={comparisons} isMobileView={isMobileView} />
      </div>
    </Container>
  </div>
);

CompetitorsComparisonsSection.propTypes = {
  comparisons: T.object.isRequired,
  competitors: T.object.isRequired,
  header: T.string,
  subheader: T.string,
  isMobileView: T.bool.isRequired,
};

export default CompetitorsComparisonsSection;
